import React, {useState} from 'react';
import styles from './donation.module.scss';
import {ActionButton} from "../action-button/action-button";
import StripeWidget from "../stripe/stripe-widget";
import LoginScreenEmail from "../login-screen-email";
import {connect} from "react-redux";
import VBox from "../ui/containers/layouts/vbox";
import {logoutUser} from "../../redux/actions/actions-user";
import APIService from "../../services/api-service/api-service";
import {isUrl} from "../../helper/validators";

const apiService = new APIService()

const Donation = ({ className, itemId, token, wording }) => {
    const amounts = ['5', '10', '25'];

    const [amountInputValue, setAmountInputValue] = useState('');
    const [amountValue, setAmountValue] = useState(amounts[2]);
    const [skipReward, setSkipReward] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stripeWidget, setStripeWidget] = useState(false);
    const [paymentUrl, setPaymentUrl] = useState(null);

    const onOptionChange = e => {
        setAmountInputValue('');
        setAmountValue(e.target.value);
    }

    const handleInputValue = e => {
        setAmountInputValue(e.target.value)
        setAmountValue(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setStripeWidget(true)
    }

    const handleCrypto = async () => {
       try {
           setLoading(true)
           const paymentLink = await apiService.getKunaPaymentIntent(itemId, amountValue, skipReward)
           if (paymentLink && isUrl(paymentLink)) {
               setPaymentUrl(paymentLink)
               window.open(paymentLink, '_blank')
           }
           setLoading(false)
       } catch (e) {
           setLoading(false)
           console.log(e)
       }
    }

    const isAmount = (amount) => amountValue === amount && !amountInputValue;

    const isPaymentRestricted = !!process.env.REACT_APP_CLOUD

    return (
        <div className={`${styles.donationSection} ${className}`}>
            {isPaymentRestricted && <h4 style={{alignText: 'left'}}>{wording['safety-notice']} <a style={{color: '#156751'}} href={'https://gronka.org'}>https://gronka.org</a></h4>}
            {!token && !isPaymentRestricted && <VBox style={{textAlign: 'left'}}>
                <strong>{wording['donation-email-notice']}</strong>
                <LoginScreenEmail />
            </VBox>}
            {token && !isPaymentRestricted &&  <VBox style={{textAlign: 'left'}}>
                <label style={{display: "flex", gap: 10}}>
                    <input style={{width: 20, height: 20}}
                           type="checkbox"
                           checked={skipReward}
                           onChange={() => setSkipReward(!skipReward)}
                    />
                    <span style={{marginTop: -3}}>{wording['skip-reward-notice']}</span>
                </label>
            </VBox>}
            {!stripeWidget && !isPaymentRestricted && <div className={styles.form}>
            <div className={styles.donateList}>
                    <div className={`${styles.box} ${isAmount(amounts[0]) ? styles.active : ''}`}>
                        <input
                            type="radio"
                            id="c1"
                            name="amount"
                            value={amounts[0]}
                            checked={isAmount(amounts[0])}
                            onChange={onOptionChange}
                        />
                        <label htmlFor="c1">
                            <span className={styles.checkIcon}></span>
                            <span className={styles.amount}>€{amounts[0]}</span>
                        </label>
                    </div>
                    <div className={`${styles.box} ${isAmount(amounts[1]) ? styles.active : ''}`}>
                        <input
                            type="radio"
                            id="c2"
                            name="amount"
                            value={amounts[1]}
                            checked={isAmount(amounts[1])}
                            onChange={onOptionChange}
                        />
                        <label htmlFor="c2">
                            <span className={styles.checkIcon}></span>
                            <span className={styles.amount}>€{amounts[1]}</span>
                        </label>
                    </div>
                    <div className={`${styles.box} ${isAmount(amounts[2]) ? styles.active : ''}`}>
                        <input
                            type="radio"
                            id="c3"
                            name="amount"
                            value={amounts[2]}
                            checked={isAmount(amounts[2])}
                            onChange={onOptionChange}
                        />
                        <label htmlFor="c3">
                            <span className={styles.checkIcon}></span>
                            <span className={styles.amount}>€{amounts[2]}</span>
                        </label>
                    </div>
                    <div className={`${styles.box} ${styles.enterAmount}`}>
                        <input
                            type="number"
                            placeholder={`-- ${wording['donation-option']} --`}
                            value={amountInputValue}
                            onChange={handleInputValue}
                        />
                    </div>
                </div>
                {!paymentUrl && <div style={{marginTop: 20}}>
                    <VBox width={'100%'} gap={10}>
                        {<ActionButton
                            className={styles.amountAction}
                            icon={false}
                            onClick={handleSubmit}
                            disabled={!token || loading}
                        >
                            {wording['pay-regular']}
                        </ActionButton>}
                        {/*<p><mark>⚠️ Данаты карткай не будуць працаваць 10.08 (тэхнічныя работы)</mark></p>*/}
                        <ActionButton secondary border
                              className={styles.amountAction}
                              icon={false}
                              onClick={handleCrypto}
                              disabled={!token || loading}
                        >
                            {wording['pay-crypto']}
                        </ActionButton>
                    </VBox>
                </div>}
                {paymentUrl && <div style={{marginTop: 20}}>{`${wording['pay-crypto-link']}`} <a href={paymentUrl} target={'_blank'} rel={'noreferrer noopener'}>{paymentUrl}</a></div>}
            </div>}
            {stripeWidget && amountValue && <div>
                <StripeWidget skipReward={skipReward} amount={Number(amountValue)*100} itemId={itemId} title={''} />
            </div>}
        </div>
    )
}

const mapStateToProps = ({  user: { token }, system: { wording } }) => {
    return { token, wording };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logoutUser: logoutUser(dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Donation);
